import Collections from './containers/Collections';

import { collectionsSelectors, CollectionsState } from './services/selectors';
import epics from './services/epics';
import reducer from './services/reducer';

export { collectionsSelectors, epics, CollectionsState, reducer };

export default Collections;



// WEBPACK FOOTER //
// ./src/scenes/Collections/index.ts